/*
 * Artisan Roast - in-basket "Upgrade to subscription"
 * Adds a small link under eligible one-off coffees in the cart drawer / cart page.
 * Clicking it switches the line to a subscription and shows a frequency dropdown
 * plus a "Switch to one-off purchase" link. Does not change any existing cart markup.
 */
(function () {
  if (window.arSubUpgrade) return;
  window.arSubUpgrade = true;

  // Only these products get the option (Shopify product handles)
  var HANDLES = ['janszoon', 'cobblestone', 'trigonometry', 'decaf'];
  // Frequency selected when someone clicks "Upgrade to subscription"
  var DEFAULT_WEEKS = 2;
  var TEXT = {
    upgrade: 'Upgrade to subscription',
    oneoff: 'Switch to one-off purchase',
    label: 'Delivery frequency'
  };

  var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  var productCache = {};
  var busy = false;
  var timer = null;

  var css =
    '.ar-sub{margin-top:12px;display:flex;flex-direction:column;align-items:flex-start;gap:10px}' +
    '.ar-sub.is-loading{opacity:.5;pointer-events:none}' +
    '.ar-sub__link{background:none;border:0;padding:0;margin:0;font:inherit;font-size:.9em;line-height:1.4;color:inherit;text-decoration:underline;text-underline-offset:3px;cursor:pointer}' +
    '.ar-sub__link--small{font-size:.8em;opacity:.7}' +
    '.ar-sub__select-wrap{position:relative;display:inline-block}' +
    '.ar-sub__select{-webkit-appearance:none;appearance:none;font:inherit;font-size:.9em;line-height:1.3;color:inherit;background:transparent;border:1px solid rgba(0,0,0,.25);border-radius:6px;padding:9px 36px 9px 12px;min-width:180px;cursor:pointer}' +
    '.ar-sub__select-wrap:after{content:"";position:absolute;right:14px;top:50%;width:7px;height:7px;border-right:1.5px solid currentColor;border-bottom:1.5px solid currentColor;transform:translateY(-70%) rotate(45deg);pointer-events:none}' +
    '.ar-sub-line .cart__item__selling-plan{display:none}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  function weeksOf(name) {
    var m = /(\d+)\s*week/i.exec(name || '');
    return m ? parseInt(m[1], 10) : 999;
  }

  function labelOf(plan) {
    var n = weeksOf(plan.name);
    if (n !== 999) return 'Every ' + n + (n === 1 ? ' week' : ' weeks');
    return plan.name.replace(/^Delivery\s+/i, '');
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function getPlans(handle, variantId) {
    if (!productCache[handle]) productCache[handle] = getJSON(root + 'products/' + handle + '.js');
    return productCache[handle].then(function (p) {
      var variant = (p.variants || []).filter(function (v) { return v.id === variantId; })[0];
      var allowed = variant && variant.selling_plan_allocations
        ? variant.selling_plan_allocations.map(function (a) { return a.selling_plan_id; })
        : null;
      var plans = [];
      (p.selling_plan_groups || []).forEach(function (g) {
        (g.selling_plans || []).forEach(function (sp) {
          if (!allowed || allowed.indexOf(sp.id) > -1) {
            plans.push({ id: sp.id, name: sp.name, weeks: weeksOf(sp.name) });
          }
        });
      });
      plans.sort(function (a, b) { return a.weeks - b.weeks; });
      return plans;
    });
  }

  function render(el, item, plans) {
    if (el.querySelector('.ar-sub')) return;
    var box = document.createElement('div');
    box.className = 'ar-sub';
    box.setAttribute('data-ar-sub', '');
    box.setAttribute('data-key', item.key);
    box.setAttribute('data-variant', item.variant_id);

    var current = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? item.selling_plan_allocation.selling_plan.id
      : null;

    if (current) {
      el.classList.add('ar-sub-line');
      var id = 'ar-sub-' + Math.random().toString(36).slice(2);
      var html = '<label class="visually-hidden" for="' + id + '">' + TEXT.label + '</label>' +
        '<div class="ar-sub__select-wrap"><select id="' + id + '" class="ar-sub__select" data-ar-sub-select>';
      plans.forEach(function (p) {
        html += '<option value="' + p.id + '"' + (p.id === current ? ' selected' : '') + '>' + esc(labelOf(p)) + '</option>';
      });
      html += '</select></div>' +
        '<button type="button" class="ar-sub__link ar-sub__link--small" data-ar-sub-oneoff>' + TEXT.oneoff + '</button>';
      box.innerHTML = html;
    } else {
      var def = plans.filter(function (p) { return p.weeks === DEFAULT_WEEKS; })[0] || plans[0];
      box.innerHTML = '<button type="button" class="ar-sub__link" data-ar-sub-upgrade data-plan="' + def.id + '">' + TEXT.upgrade + '</button>';
    }

    var anchor = el.querySelector('.cart__item__bottom');
    if (anchor) anchor.insertAdjacentElement('afterend', box);
    else (el.querySelector('.cart__item__content') || el).appendChild(box);
  }

  function process() {
    if (busy) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-cart-item][data-item]:not([data-ar-sub-done])'));
    if (!els.length) return;
    els.forEach(function (el) { el.setAttribute('data-ar-sub-done', ''); });

    getJSON(root + 'cart.js').then(function (cart) {
      els.forEach(function (el) {
        var key = el.getAttribute('data-item');
        var item = (cart.items || []).filter(function (i) { return i.key === key; })[0];
        if (!item || HANDLES.indexOf(item.handle) === -1) return;
        getPlans(item.handle, item.variant_id).then(function (plans) {
          if (plans.length) render(el, item, plans);
        }).catch(function () {});
      });
    }).catch(function () {
      els.forEach(function (el) { el.removeAttribute('data-ar-sub-done'); });
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(process, 60);
  }

  function refresh(box, oldKey, variantId, plan, cart) {
    // Find the line as it is now (its key changes when the plan changes)
    var line = (cart.items || []).filter(function (i) {
      if (i.variant_id !== variantId) return false;
      var p = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan ? i.selling_plan_allocation.selling_plan.id : null;
      return p === plan;
    })[0];
    var el = box.closest('[data-cart-item]');
    if (!line || !el) { window.location.reload(); return; }
    // Ask the theme to redraw the basket (prices, totals, free-shipping bar)
    // using its own line-update event, with the same quantity so nothing else changes
    el.dispatchEvent(new CustomEvent('theme:cart:update', {
      bubbles: true,
      detail: { id: line.key, quantity: line.quantity }
    }));
    // Fallback: if the theme didn't redraw, reload so the basket is accurate
    setTimeout(function () {
      var stale = document.querySelector('[data-item="' + oldKey + '"] .ar-sub.is-loading');
      if (stale) window.location.reload();
    }, 3000);
  }

  function change(box, plan) {
    if (busy) return;
    busy = true;
    box.classList.add('is-loading');
    var key = box.getAttribute('data-key');
    var variantId = Number(box.getAttribute('data-variant'));
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, selling_plan: plan })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    }).then(function (cart) {
      busy = false;
      refresh(box, key, variantId, plan, cart);
    }).catch(function () {
      window.location.reload();
    });
  }

  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-ar-sub-upgrade]');
    var off = e.target.closest('[data-ar-sub-oneoff]');
    if (!up && !off) return;
    e.preventDefault();
    e.stopPropagation();
    var box = (up || off).closest('[data-ar-sub]');
    change(box, up ? Number(up.getAttribute('data-plan')) : null);
  }, true);

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-ar-sub-select]');
    if (!sel) return;
    change(sel.closest('[data-ar-sub]'), Number(sel.value));
  });

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
